import type { BehaviorDocument } from "../types";
import { createNodeId } from "../types";

export const GO2_WALK_TEMPLATE_ID = "builtin_go2_walk_v1";

export function createGo2WalkTemplate(): BehaviorDocument {
  const nRoot = createNodeId();
  const nWalk = createNodeId();
  return {
    id: GO2_WALK_TEMPLATE_ID,
    name: "Go2 Walk (template)",
    isTemplate: true,
    baselineSnapshot: null,
    rootId: nRoot,
    nodes: {
      [nRoot]: {
        id: nRoot,
        kind: "sequence",
        label: "Go2 walk flow",
        children: [nWalk],
      },
      [nWalk]: {
        id: nWalk,
        kind: "runTrainedModel",
        label: "Go2 Walk",
        modelId: "go2-walk-stagef",
        durationSeconds: 6,
        commandVx: 0.25,
        commandWz: 0,
      },
    },
  };
}
